module.exports = __webpack_public_path__ + "static/TelegraphTower-Plans-8cb7422484ff15248d7d6fe632b4fa45.pdf";